// extracted by mini-css-extract-plugin
export default {"animated-cloud":"AnimatedCloud_animated-cloud__t7gJ6"};